import Prefixes from './arrays/prefixes'
import Countries from './arrays/countries'
import Locations from './arrays/locations'
import Sexes from './arrays/sexes'
import YesNo from './arrays/yesno'
import Length from './arrays/length'
import Displacement from './arrays/displacement'
import Towings from './arrays/towings'

export default {
  yesno: YesNo,
  prefixes: Prefixes,
  countries: Countries,
  locations: Locations,
  sexes: Sexes,
  length: Length,
  displacement: Displacement,
  towings: Towings,
  title: 'Français',
  home: {
    title: "Nous sommes unis par les distances",
    subtitle: "DONNANT SERVICE DEPUIS 1977",
  },
  header: {
    routesandschedules: "itinéraires et horaires",
    travelbyferry: "voyage en ferry",
    customersupport: "service client",
    aboutromeu: "ferries romeu",
    locatereservation: "localisez réservation",
    ferrysalicante: "Ferries à partir d'Alicante",
    ferrysbarcelona: "Ferries à partir de Barcelone",
    ferrysoran: "Ferries vers Oran",
    ferrysmostaganem: "Ferries vers Mostaganem",
    ferrysargel: "Ferries vers Alger",
  },

  cities: {
    ferrysa: "Ferries depuis",
    ferrysb: "Ferries depuis",
    alicante: "ALICANTE",
    barcelona: "BARCELONE",
    oran: "ORAN",
    argel: "ALGER",
    mostaganem: "MOSTAGANEM",
  },
  headernav: {
    yourselection: "VOTRE SÉLECTION ",
    yourdata: "TES DONNÉES",
    summary: "SOMMAIRE ET PAIEMENT",
    confirmation: "CONFIRMATION RÉSERVATION",
  },

  information: {
    attentiontitle: "Service",
    attentionsubtitle: "CLIENT",
    attentiontext: "",

    routestitle: "Ferries",
    routessubtitle: "ITINÉRAIRES ET HORAIRES",
    routestext: "",

    abouttitle: "À propos des",
    aboutsubtitle: "ROMEU FERRIES",
    abouttext: "Romeu y Cia est une entreprise familiale fondée à Tarragone vers la moitié du XIX ème siècle et s'est fortement consolidée en 1939 quand les frères Ernesto et Manuel Romeu Escandell ont assumé sa direction. Au sein du département de consignation de navires, le réseau de succursales s'est peu à peu étendu, d'abord dans les principales villes portuaires espagnoles et plus tard en Afrique du Nord et sur le continent Américain.",
    formtitle: "FORMULAIRE DE CONTACT",
    knowmorre: "SAVOIR PLUS",
  },

  locatereserve: {
    title: "Localisez votre réservation",
    description: "Entrez votre code de réservation pour télécharger le bon pour celui-ci.",
    reserve: "Code de réservation",
    error: "Code de réservation non trouvée",
    buttonsearch: "Localiser",
    message: "Attention, rappelez-vous qu'avec la réservation vous devez obtenir la carte d'embarquement dans le terminal",
    condition: "S'il vous plaît, vérifiez nos conditions d'utilisation.",
    buttonprint: "réservation d'impression",
    buttondownload: "télécharger la réservation",
  },

  fastbooking: {
    calendar: {
      daysshort: ["LUN", "MAR", "MER", "JEU", "VEN", "SAM", "DIM"],
      daysname: ["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", "Dimanche"],
      monthnames: ["JANVIER", "FÉVRIER", "MARS", "AVRIL", "MAI", "JUIN",
          "JUILLET", "AOÛT", "SEPTEMBRE", "OCTOBRE", "NOVEMBRE", "DÉCEMBRE"],

      monthshort: ["JAN.", "FEV.", "MAR.", "AVR.", "MAI.", "JUI.",
          "JUL.", "AOU.", "SEP.", "OCT.", "NOV.", "DEC."]
    },
    travels:{
      roundtrip: "ALLER ET RETOUR",
      onlygoing: "ALLER",
    },
    tabs: {
      going: "aller",
      return: "retour",
      roundtrip: "Aller et Retour",
      passengers: "passager/s",
      vehicles: "véhicule/s",
      find: "trouver",
    },
    origin: {
      origin: 'ORIGINE',
      destiny: 'DESTINATION',
      confirmrute: 'CONFIRMER LE TRAJET',
    },
    passengers: {
      adults: "ADULTE/S",
      adultsdetails: "Plus de 26 ans",
      teens: "JEUNE/S",
      teensdetails: "De 12 à 26 ans",
      kids: "ENFANT/S",
      kidsdetails: "De 3 à 12 ans",
      babys: "BÉBÉ/S",
      babysdetails: "Moins de 3 ans",
      pets: "Chiens",
      petsdetails: "Seulement des chiens",
      family: "Famille nombreuse",
      couple: "Couple voyageant ensemble",
      confirm: "CONFIRMER PASSAGERS",
    },
    vehicles: {
      cars: "TOURISME/S",
      carsdetails: "Véhicule jusqu'à 5 places",
      vans: "FOURGON/S",
      vansdetails: "Fourgonettes, autocaravanes",
      motorcycles: "MOTO/S",
      motorcyclesdetails: "Motocyclettes, scooters ...",
      bikes: "VÉLO/S",
      bikesdetails: "Véhicules non motorisés",
      towings: "REMORQUE/S",
      towingsdetail: "Remorques et caravanes",
      confirmvehicles: "CONFIRMER LE VÉHICULES",
      confirmnovehicles: "JE VOYAGE SANS VÉHICULE",
    },
    departure: {
      selectdate: "SÉLECTIONNER LA DATE DE DÉPART",
      confirm: "CONFIRMER L' ALLER",
      find: "RECHERCHER FERRY",
    },
    return: {
      selectdate: "SÉLECTIONNER LA DATE DE RETOUR ",
      find: "RECHERCHER FERRY",
    }
  },

  lastFooter : {
    content: "Romeu y Cía., tous droits réservés. Avinguda Diagonal 403, 4ª étage · Téléphone: +34 93 292 21 21 · Fax: +34 93 415 07 07 · Email: <a class=\"white-link\" href=\"mailto:pasajes@romeuycia.com\">pasajes@romeuycia.com</a>",
  },

  footer : {
    legal: "Avis juridique",
    conditions: "Conditions d'utilisation",
    privacitat: "Politique de confidentialité",
    cookies: "Politique de cookies",
  },
  faqs : {
    title: "Voyager en ferry",
    plazasTit: "Installations",
    plazasP: "Nos ferries disposent  de plusieurs catégories offertes aux passagers :",
    plazasText: ["- Fauteuil touriste","- Couchette: chambre(à  partager)de 4 lits avec lavabo.","- Cabine intérieure ou extérieure ( à partager) de 2 ou 4 lits. Elles disposent d'une salle de bain complète avec climatisation, dîner et petit déjeuné compris."],
    reservaTit: "Effectuer une réservation",
    reservaText: "Une fois la réservation réalisée on line le système émettra un numéro de réservation provisoire. Après  confirmation des places disponibles, nous vous enverrons dans un délai de 24 heures à votre adresse mail, un courrier avec le billet en pièce jointe qui devra être imprimé et être présenté au guichet le jour du voyage pour obtenir la carte d'embarquement.",
    documentacionTit: "Documents nécéssaires pour voyager",
    documentacionText: ["- Passagers:  passeport en règle et avec visa en vigueur.","- Vehicules: Carte grise.","- Véhicules d' exportation: documents du véhicule et papiers d'exportation.","- Animaux de compagnie: Carnet de vaccination en règle."],
    targetaTit: "Les cartes d'embarquement",
    targetaText: "Se Présenter au guichet 3 heures avant le départ du navire avec le billet imprimé, les passeports de tous les passagers ainsi que la carte grise du véhicule.",
    pasajeros: "Passagers",
    any: "- En ce qui concerne les tarifs aller-retour pour une durée d'un an nous proposons 5 catégories:",
    anylist: ["- Bébés:  de 0 à 2 ans.","- Enfant: de 3 à 11 ans.","- Jeune:  de 12 à 25 ans.","- Adulte: de 26 à 54 ans.","- Senior: à partir de 55 ans."],
    sesenta: "- Pour les  Tarifs promotionnels aller-retour valable 60 jours, nous proposons 3 catégories:",
    sesentalist: ["- Bébés: 0 à 2 ans","- Enfant:de 3 à 11 ans.","- Adulte: à partir de 12 ans."],
    seis: "- En ce qui concerne les tarifs pour aller-retour valable 6 mois il n'y a pas de distinction relative à l âge des passagers sauf s'il s'agit de bébés  (de 0 à 2 ans) pour qui le trajet sera gratuit.",
  },
  Secctiontext : {
    title: "À propos des Ferries Romeu",
    tuno: "Histoire",
    puno: "Romeu y Cia est une entreprise familiale fondée à Tarragone vers la moitié du XIX ème siècle et s'est fortement consolidée en 1939 quand les frères Ernesto et Manuel Romeu Escandell ont assumé sa direction. Au sein du département de consignation de navires, le réseau de succursales s'est peu à peu étendu, d'abord dans les principales villes portuaires espagnoles et plus tard en Afrique du Nord et sur le continent Américain. En plus de son activité relative au transport de passagers,  l'entreprise centre aussi son activité dans la consignation de navires marchands en  représentation des compagnies maritimes réalisant des trajets vers tous les points du monde. Pour plus d'information, n'hésitez pas à consulter notre page web",
    tdos: "Qui sommes nous?",
    pdos: "Romeu ferries est une division de l'entreprise Romeu y Cia S.A. et appartenant au Groupe Romeu, un puissant Holding logistique espagnol ayant une large trajectoire dans le secteur du transport maritime. En 1977, Romeu a commencé sa collaboration au port d'Alicante avec la compagnie d'État  algérienne de ferries ENTMV  et est depuis cette date son agent maritime permettant, grâce à cette collaboration, la croissance et la consolidation du service aux voyageurs. Depuis lors, notre entreprise est devenue une référence pour la ville d'Alicante où tous les ans transitent et passent, principalement lors de la campagne estivale , des milliers de personnes avec leurs véhicules pour effectuer la traversée vers les principaux ports algeriens à bord des navires de l'ENTMV. En 2017, une nouvelle route complémentaire a été créée depuis le port de Barcelone vers l' Algérie afin de pouvoir continuer à offrir de nouvelles alternatives aux passagers de la ligne maritime.",
    ttres: "Que faisons nous?",
    ptres: "Durant la deuxième partie du XX ème siècle, suite à la croissance de l'activité de consignation, l'entreprise a commencé à développer d' autres activités dans le secteur des transports telles que le stockage de marchandises, agences douanières, transitaires etc. ce qui a amené le groupe Romeu à être reconnu comme l'un des principaux Holdings espagnols pour le domaine de la logistique internationale de marchandises avec une expansion de plus en plus ample de son activité et réseau grâce à l'implantation de nouvelles délégations  en Europe, Afrique, Amérique et Asie. Il reste à souligner que le groupe continue à être dirigé intégralement par la famille ROMEU. Pour plus d'information consulter notre web.",
  },
  noAvailableFerriesText: "Désolé, aucun ferry disponible.",
  table : {
    alicante: {
      title: "Ferries à partir d'Alicante",
      text: "Durant la période estivale, départs/arrivées quotidiens avec pour destination/origine Oran. Le reste de l'année  (en dehors de la période estivale) départs/arrivées hebdomadaires avec destination/origine Oran. Départs/arrivées sporadiques selon le calendrier avec origine/destination Alger et Mostaganem.",
      departure: "Sortie",
      departureArrival: "Heure de départ / arrivée",
      duration: "Durée",
      destination: "La destination",
      origin: "Origine",
      vessel: "Navire"
    },
    barcelona: {
      title: "Ferries à partir de Barcelone",
      text: "Durant la période estivale, départs/ arrivées hebdomadaires avec destination/origine Mostaganem. Le reste de l'année Départs/arrivées tous les 15 jours avec destination/origine Mostaganem. Départs/arrivées sporadiques selon le calendrier avec origine/destination Alger et Oran.",
      departure: "Sortie",
      departureArrival: "Heure de départ / arrivée",
      duration: "Durée",
      destination: "La destination",
      origin: "Origine",
      vessel: "Navire"
    },
    mostaganem: {
      title: "Ferries vers Mostaganem",
      text: "Pendant les mois d'été, départs / arrivées par semaine avec origine / destination Barcelone. Reste de l'année, départs / arrivées aux deux semaines avec destination Barcelone. Aussi départs/arrivées sporadiques avec origine/destination Alicante",
      departure: "Sortie",
      departureArrival: "Heure de départ / arrivée",
      duration: "Durée",
      destination: "La destination",
      origin: "Origine",
      vessel: "Navire"
    },
    argel: {
      title: "Ferries vers Alger",
      text: "Départs/arrivées occasionnels avec origine/destination Alicante et Barcelone",
      departure: "Sortie",
      departureArrival: "Heure de départ / arrivée",
      duration: "Durée",
      destination: "La destination",
      origin: "Origine",
      vessel: "Navire"
    },
    oran: {
      title: "Ferries vers Oran",
      text: "Pendant les mois d'été, départs/arrivées tous les jours avec origine/destination Alicante. Reste de l'année, départs/arrivées par semaine avec origine/destination Alicante. Aussi départs/arrivées sporadiques avec origine/destination Barcelone",
      departure: "Sortie",
      departureArrival: "Heure de départ / arrivée",
      duration: "Durée",
      destination: "La destination",
      origin: "Origine",
      vessel: "Navire"
    },

  },

  search: {
    promotitle: "!Promotions aller-retour disponibles!",
    promos: {
      '60days': "Retour avant 60 jours",
      '6months-al': "Retour avant 6 mois",
      '6months-ba': "Retour avant 6 mois",
    },
    promomessage: "Les promotions ne sont valables que pour un maximum de 5 passagers",
    going: "Aller",
    return: "Retour",
    confirm: "CONTINUER VOTRE RÉSERVATION",
    travel: {
      departure: "Départ",
      arrival: "Arrivée",
      duration: "Durée",
      boatname: "Nom navire",
      Reservation: "Réservation",
    },
  },

  dataresume: {
    contacttitle: "Coordonnées de contact",
    contacttext: "Tous les champs sont obligatoires L'adresse e-mail et le mobile seront utilisés pour vous informer de toute nouvelle qui pourrait survenir pendant votre voyage, ainsi que pour vous envoyer un e-mail rappelant votre réservation.",
    contactequal: "Les données du passager correspondent aux informations de contact",
    passengerstitle: "Information des passager",
    vehicletitle: "Données du véhicule",
    confirm: "CONFIRMER LES DONNÉES",
    previous: "RETOURNER EN ARRIÈRE",
    passenger: "Passager",
    vehicle: "Véhicule",
    adult: "ADULTE",
    teen: "JEUNE",
    kid: "ENFANT",
    baby: "BÉBÉ",
    car: "TOURISME",
    van: "FOURGON",
    motorcycle: "MOTO",
    towing: "REMORQUE",
    names: {
      name: 'Nom',
      surname: 'Prénom',
      namesurname: "Prénom et nom",
      secondSurname: 'Deuxième nom de famille (facultatif)',
      numberDocument: 'Nº de passeport',
      prefix: 'Préfixe',
      phone: 'Téléphone portable',
      email: 'Email',
      repeatEmail: 'Répéter email',
      postalcode: 'C.P.',
      locationGone: 'Installation Aller',
      locationReturn: 'Installation Retour',
      nationality: 'Nationalité',
      birthDate: 'Date Nai.',
      birthDate2: 'Date de naissance',
      gender: 'Sexe',
      brand: 'Marque',
      model: 'Modèle',
      licensePlate: 'Immatriculation',
      exported: "Véhicule d'exportation",
      length: 'Longueur (m)',
      displacement: 'Cilindrada',
      towing: 'Remorque',
    },
    errors: {
      heisrequired: "Le XXX est requis",
      sheisrequired: "La XXX est requise",
      incorrectformat: "L'email a un format incorrect",
      incorrectformatdate: "Le format est incorrect",
      duplicatemail: "L'email répété ne correspond pas à l'email entré",
    },
  },

  resume: {
    infotext: "Nous présentons ici le résumé de votre réservation afin que vous puissiez le confirmer et finaliser l'achat en ligne. Une fois que vous aurez cliqué sur le bouton de confirmation, vous procéderez au paiement dans la passerelle de paiement de notre banque, en revenant sur notre site Web lorsque le processus sera terminé.",
    passengersinfo: "Passenger information",
    editdetails: "EDITER LES DONNÉES",
    vehiclesinfo: "Vehicle data",
    confirm: "CONFIRMER LES DONNÉES ET LE PAIEMENT",
    breakdown: {
      title: "Répartition de la réservation",
      tripgoing: "Voyage aller",
      tripreturn: "Voyage de retour",
      departuredate: "Date de sortie",
      departuretime: "Heure de sortie",
      reservation: "Réservation",
      vehicles: "Véhicules",
      totalgoing: "Total aller",
      totalreturn: "Total de retour",
      totalreservation:"Total réservation",
      adult: "Passager adulte (plus de 26 ans)",
      teen: "Passager jeune (de 12 à 26 ans)",
      kid: "Passager enfant (de 3 à 12 ans)",
      baby: "Bébé (moins de 3 ans)",
      pet: "Chiens",
      car: "Tourisme",
      van: "Van / Camping-car",
      motorcycle: "Moto",
      towing: "Remorque / Caravane",
      bike: "Vélo",
    },
    contactinformation: {
      title: "Coordonnées",
      namesurname: "Prénom et nom",
      passport: "Nº de passeport",
      phone: "Téléphone",
      email: "Email",
      postalCode: "Code postal",
    },
  },

  confirmation: {
    info: "Votre réservation a été faite, alors vous pouvez télécharger et imprimer votre réservation. Nous avons également envoyé toutes les données à l'adresse e-mail de contact. Merci d'utiliser nos services en ligne.",
    reservation: "Numéro de réservation",
    message: "Attention, rappelez-vous qu'avec la réservation vous devez obtenir la carte d'embarquement dans le terminal",
    condition: "S'il vous plaît, vérifiez nos conditions d'utilisation.",
    buttonprint: "réservation d'impression",
    buttondownload: "télécharger la réservation",
    errorTitle: "Erreur lors du paiement, contactez-nous.",
    errormessange: "Numéro de téléphone de contact: +34 965 147 010",
  },

  legal: {
    notices: {
      warning: {
        title: "Aviso legal",
        content: `
          <p>
            ROMEU Y CIA. S.A., en cumplimiento de la normativa vigente en materia de protección de datos de carácter personal
            (Ley Orgánica 15/1999, de 13 de diciembre de Protección de Datos de Carácter Personal) , así como la regulación
            existente en materia de servicios de la sociedad de la información y comercio electrónico (Ley 34/2002, de 11 de
              julio de servicios de la sociedad de la información y correo electrónico) pone en su conocimiento las presentes
              condiciones generales de uso que se aplican a todas las operaciones realizadas a través de la web:
              www.romeuycia.com
          </p>
          <p>
            De conformidad con la Ley 34/2002, de 11 de julio, de servicios de la sociedad de la información y de comercio
            electrónico” en vigor desde julio de 2002, comunicamos que este sitio web pertenece a:
          </p>
          <p>
            <div>Nombre fiscal de la sociedad: ROMEU Y CIA. S.A.</div>
            <div>CIF de la sociedad: A-28402006</div>
            <div>Domicilio de la sociedad: C/ Jorge Juan, 6, 03002, Alicante</div>
            <div>Teléfono: +34 93 292 21 25.Fax: +34 93 415 07 07</div>
            <div>Correo electrónico: barcelona@romeuycia.com</div>
            <div>Datos legales y/o registrales de la sociedad: Inscrita en el Registro Mercantil de Madrid,
              Tomo 3,757, Folio 19, Hoja 28,718. Inscripción 1.ª</div>
          </p>
          <h3>Condiciones de uso</h3>
          <h4>1. Propiedad intelectual de la web</h4>
          <p>
            Todos los derechos de propiedad intelectual del contenido de esta página web, su diseño gráfico y sus códigos fuente,
            son titularidad exclusiva de ROMEU Y CIA. S.A. a quien le corresponde el ejercicio exclusivo de los derechos de
            explotación de los mismos. Por tanto queda prohibida su reproducción, distribución, comunicación pública y
            transformación, total o parcial, sin la autorización expresa de ROMEU Y CIA. S.A. Igualmente, todos los nombres
            comerciales, marcas o signos distintos de cualquier clase contenidos en este web site están protegidos por ley.
          </p>
          <h4>2. Contenido de la web y enlaces</h4>
          <p>
            ROMEU Y CIA. S.A., no se responsabiliza del mal uso que se realice de los contenidos de su página web, siendo
            exclusiva responsabilidad de la persona que accede a ellos o los utiliza. Tampoco asumimos ninguna responsabilidad
            por la información contenida en las páginas web de terceros a las que se pueda acceder por enlaces o buscadores
            desde la página web romeuycia.com.
          </p>
          <h4>3. Utilización ilícita</h4>
          <p>
            El usuario de esta página web y de sus servicios se obliga a realizar un uso conforme con las leyes y los usos del
            tráfico y se abstendrá de utilizar la web y sus servicios con fines o efectos ilícitos o que sean lesivos de los
            derechos e intereses de terceros o que de cualquier forma puedan dañar, inutilizar sobrecargar o deteriorar la web
            y los servicios o impedir la normal utilización de la web y de los servicios por parte de los usuarios. Quienes
            incumplan esta obligación responderán frente a ROMEU Y CIA. S.A. y frente a terceros de cualesquiera daños y perjuicios
            que puedan causarse a consecuencia del incumplimiento de dicha obligación.
          </p>

          <h4>4. Garantía de errores</h4>
          <p>
            ROMEU Y CIA. S.A. no garantiza la inexistencia de errores en el acceso a la web, o en su contenido; en el caso que se
            citen o reproduzcan publicaciones de carácter oficial, dicha reproducción tendrá carácter meramente informativo
            debiendo considerarse a todos los efectos como válida la publicación en su boletín o fuente oficial correspondiente.
          </p>
          <h4>5. Intercambio o difusión de información</h4>
          <p>
            ROMEU Y CIA. S.A., declina toda responsabilidad que se derive del intercambio de información entre usuarios a través
            de su página web.
          </p>
          <h4>6. Actualización y modificación de la página web</h4>
          <p>
            ROMEU Y CIA. S.A. se reserva el derecho a actualizar, modificar o eliminar la información contenida en su web site,
            y la configuración o presentación del mismo, en cualquier momento, sin previo aviso, y sin asumir responsabilidad
            alguna por ello.
          </p>
          <h4>7. Indicaciones sobre aspectos técnicos</h4>
          <p>
            ROMEU Y CIA. S.A. no asume ninguna responsabilidad que se pueda derivar de problemas técnicos o fallos en los equipos
            informáticos, no imputables a nuestra Sociedad, que se produzcan durante la conexión a la red de Internet, así como
            de daños que pudieran ser causados por terceras personas mediante intromisiones ilegítimas fuera del control de
            ROMEU Y CIA. S.A. También quedamos exonerados de toda responsabilidad ante posibles daños o perjuicios que pueda
            sufrir el usuario a consecuencia de errores, defectos u omisiones en la información que facilitemos cuando proceda
            de fuentes ajenas a nosotros.
          </p>
          <h4>8. Legislación y jurisdicción aplicables</h4>
          <p>
            Con carácter general, las relaciones con nuestros clientes, que se deriven de la prestación de los servicios
            contenidos en nuestra web, están sometidas a la legislación y la jurisdicción española. Cualquier disputa que
            pueda surgir en la interpretación de estas condiciones se resolverá en los tribunales del lugar donde tenga su
            domicilio social ROMEU Y CIA. S.A. Los usuarios de nuestra web son conscientes de todo lo expuesto y lo aceptan
            voluntariamente.
          </p>
        `,
      },
      conditions: {
        title: "Condiciones de servicio",
        content: `
          <h3>Datos fiscales del comercio</h3>
          <p>
            <div>Nombre fiscal de la sociedad: ROMEU Y CIA. S.A.</div>
            <div>CIF de la sociedad: A-28402006</div>
            <div>Domicilio de la sociedad: C/ Jorge Juan, 6, 03002, Alicante</div>
            <div>Teléfono: +34 93 292 21 25.Fax: +34 93 415 07 07</div>
            <div>Correo electrónico: barcelona@romeuycia.com</div>
            <div>Datos legales y/o registrales de la sociedad: Inscrita en el Registro Mercantil de Madrid,
              Tomo 3,757, Folio 19, Hoja 28,718. Inscripción 1.ª</div>
          </p>
          <h3>Política de venta, devolución y cancelación de reserva</h3>
          <p>Romeu y Cía, a través de su sitio web romeuferries.com realizar venta de reservas de billetes para
            transporte marítimo.</p>
          <p>
            Dichas reservas no garantizan la disponibilidad del billete solicitado. En caso de no haber disponibilidad
            en las fechas solicitadas, se devolverá a los usuarios el importe íntegro abonado y se le informará por
            correo electrónico para que pueda volver a hacer otra reserva.
          </p>
          <p>
            La anulación o cambio de fechas por parte del pasajero de la reserva del billete, incurrirá en una penalización
            del 20% del importe del mismo si la anulación se realiza antes de las 72 horas precedentes a la salida del buque.
          </p>
          <p>
            Si la  anulación de los billetes se realiza dentro de las 72 horas antes de salida del buque existirá una
            penalización por el total del importe del billete. 
          </p>
          <p>
            Para el reembolso de un billete emitido Romeu y Cía. (o Romeu Ferries), el interesado deberá dirigirse a
            cualquiera de las oficinas de la compañía. El reembolso se efectuará en función de la forma de pago del billete,
            en ningún caso serán reembolsables los gastos de emisión.
          </p>
          <h3>Política de entrega de billetes </h3>
          <p>
            Todas aquellas reservas realizadas a través de este sitio web y que hayan sido aceptadas pasarán a tramitar el
            correspondiente billete. 
          </p>
          <p>
            En un máximo de 24 horas hábiles los usuarios recibirán el billete correspondiente a la reserva solicitada a través
            de correo electrónico.
          </p>
          <p>
            Será obligatorio para todos los usuarios presentar el o los billetes en las ventanillas de la terminal en la fecha
            correspondiente para obtener las tarjetas de embarque con las que poder subir a bordo del buque. 
          </p>
        `
      },
      privacy: {
        title: "Política de Privacidad",
        content: `
          <p>
            En cumplimiento de lo establecido en la Ley Orgánica 15/1999, de 13 de diciembre, de Protección de Datos de
            Carácter Personal, ROMEU Y CIA. S.A., informa a sus clientes de que cuantos datos personales le faciliten
            serán incluidos en un fichero automatizado de datos de carácter personal, creado y mantenido bajo la responsabilidad
            de ROMEU Y CIA. SA. La finalidad de dicho fichero es enviar ofertas comerciales en el futuro sobre productos y
            servicios que puedan resultar de interés a nuestros clientes. ROMEU Y CIA. S.A., garantiza la seguridad y
            confidencialidad de los datos facilitados. De este modo, se compromete al cumplimiento de su obligación de secreto
            de los datos de carácter personal y de su deber de guardarlos y adoptar todas las medidas necesarias para evitar
            su alteración, pérdida, tratamiento o uso no autorizado. Por lo tanto, toda la información sobre nuestros clientes
            no será utilizada con propósitos comerciales ni será cedida a terceros. Los clientes de ROMEU Y CIA. S.A. podrán en
            todo momento ejercitar los derechos de acceso, rectificación, cancelación y oposición, comunicándose por escrito a
            nuestra dirección de correo electrónico: pasajes@romeuycia.com
          </p>
        `,
      },
      cookies: {
        title: "Política de Cookies",
        content: `
          <h3>Definición y función de las cookies</h3>
          <p>
            Una cookie es un fichero que se descarga en su ordenador (el del usuario), tras acceder a determinadas
            páginas web. Las cookies permiten a una página web, entre otras cosas, almacenar y recuperar información
            sobre los hábitos o preferencias de navegación de un usuario o de su equipo, con el fin de mejorar el
            funcionamiento de los sitios web y para proporcionar información analítica, comercial y de marketing.
          </p>
          <h3>Cookies utilizadas en nuestro sitio web</h3>
          <p>
            En el presente sitio web romeuferries.com de Romeu y Cía. S.A.existen las siguientes cookies:
          </p>
          <h4>1. Cookies propias</h4>
          <p>
            No existen cookies propias implementadas
          </p>
          <h4>2. Cookies de terceros</h4>
          <p>
            A continuación se detallan las cookies de terceros utilizadas en el sitio web romeuferries.com.
          </p>
          <table>
            <tr>
              <th>Tipo</th>
              <th>Nombre</th>
              <th>Duración</th>
              <th>Finalidad</th>
            </tr>
            <tr>
              <td>Analítica</td>
              <td>_utma</td>
              <td>Caduca a los 2 años</td>
              <td>
                Cookie establecida por Google Analytics para registrar la fecha de la primera y última visita de un usuario.
                Al mismo tiempo, se utiliza para hacer recuento de cuantas veces visita la web un único usuario.
              </td>
            </tr>
            <tr>
              <td>Analítica</td>
              <td>_utmb</td>
              <td>Caduca a los 30 minutos desde el último registro de página vista</td>
              <td>
                Cookie establecida por Google Analytics para registrar la hora de llegada a la web con el objetivo de
                calcular el tiempo que permanece en ella.
              </td>
            </tr>
            <tr>
              <td>Analítica</td>
              <td>_utmc</td>
              <td>Caduca al terminar la sesión</td>
              <td>
                Cookie establecida por Google Analytics para registrar la hora de llegada a la web con el objetivo de
                calcular el tiempo que permanece en ella.
              </td>
            </tr>
            <tr>
              <td>Analítica</td>
              <td>_utmz</td>
              <td>Caduca a los 6 meses</td>
              <td>
                Cookie establecida por Google Analytics para identificar el camino que ha seguido el usuario para acceder
                a la web, ya sea a través de acceso directo, desde un link de otra web, enlace de correo electrónico...
              </td>
            </tr>
            <tr>
              <td>Analítica</td>
              <td>_ga</td>
              <td>Caduca a los 2 años</td>
              <td>
                Cookie de Google Analytics que habilita la función de control de visitas únicas. La primera vez que un
                usuario entre en el sitio web a través de un navegador se instalará esta cookie. Cuando este usuario vuelva
                a entrar en la web con el mismo navegador, la cookie considerará que es el mismo usuario. Solo en el caso
                de que el usuario cambie de navegador, se considerará otro usuario.
              </td>
            </tr>
          </table>
          <h3>Cómo desactivar las cookies</h3>
          <p>
            Para cumplir con la legislación vigente, tenemos que pedir su permiso para gestionar cookies. Si decide no autorizar
            el tratamiento indicándonos su no conformidad, sólo usaríamos las cookies que son imprescindibles para la navegación
            por nuestra web. En este caso, no almacenaríamos ninguna cookie. En el caso de que siga navegando por nuestro
            sitio web sin denegar su autorización implica que acepta el uso de las cookies.
          </p>
          <p>
            Tenga en cuenta que si rechaza o borra las cookies de navegación, no podremos mantener sus preferencias, algunas
            características de las páginas no estarán operativas, no podremos ofrecerle servicios personalizados y cada vez
            que vaya a navegar por nuestra web tendremos que solicitarle de nuevo su autorización para el uso de cookies.
          </p>
          <p>
            Puede modificar, antes de dar su consentimiento (seguir navegando por nuestra web),  la configuración de acceso
            a la página web para evitar el uso de cookies en su equipo en cualquier momento, así como revocar el consentimiento
            ya prestado para el uso de las mismas en su navegador, desactivando o eliminando las cookies ya instaladas mediante
            la modificación de los parámetros de configuración de su navegador.
          </p>
        `,
      }
    }
  },

  sectionContact: {
    customerServicePhone: "Téléphone du service client",
    customerServiceSchedule: "Du lundi au vendredi de 9h00 à 14h00 et de 16h00 à 19h00",
    title: "Formulaire de contact",

    form: {
      submit: "Envoyer",
      optional: "Optionnel",
      fields: {
        name: "Nom",
        surname: "Prénom",
        secondSurname: "Deuxième nom de famille (facultatif)",
        email: "Email",
        repeatEmail: "Répéter email",
        prefix: "Préfixe",
        phone: "Téléphone portable",
        queryType: "Type de requête",
        queryMessage: "Écrivez la requête ici",
        privacyCheck: "J'ai lu et accepté la politique de confidentialité"
      },
      queryTypes: {
        0: "Information",
        1: "Suggestion",
        2: "Réclamation",
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/routers/languages/fr/index.js